import { Component, Watch, Mixins } from 'vue-property-decorator';
import { PassObj, UpdatePasswordObj } from '@/Model/model';
import passwordStore from '@/store/modules/password';
import commonEntry from '@/store/modules/commonEntry';
import config from '@/config';
import UIkit from 'uikit';
import PasswordComponent from '@/commoncomponents/passwordcomponent/PasswordComponent.vue';
import ConfirmationPopup from '@/popupcomponents/confirmationPopup/ConfirmationPopup.vue';
import AccountSettings from '@/mixins/accountSettings.mixin';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
@Component({
  components: {
    'change-password': PasswordComponent,
    'update-pass-confirmation': ConfirmationPopup
  }
})
export default class ChangePassword extends Mixins(AccountSettings, DeviceWidthCheckerMixin) {
  public typeobj: PassObj = config.changePassObj;
  public confirmPassObj: any = {};
  public reload: boolean = false;
  public closeErrorMsg: boolean = true;
  public closeChangePassword: boolean = false;

  /* istanbul ignore next */
  get submitResponse(): object {
    return commonEntry.getSubmit;
  }

  public onSubmit(): void {
    this.reload = false;
    const registerObj: any = {};
    registerObj.type = this.typeobj.type;
    registerObj.oldPassword = passwordStore.getOldPassword;
    registerObj.password = passwordStore.getPassword;
    registerObj.confirmPassword = passwordStore.getConfirmPassword;
    this.confirmPassObj = {
      oldPassword: passwordStore.getOldPassword.length,
      password: passwordStore.getPassword.length,
      confirmPassword: passwordStore.getConfirmPassword.length
    };
    /* istanbul ignore next */
    if (registerObj.oldPassword.length !== 0 && registerObj.password.length !== 0 && registerObj.confirmPassword.length !== 0) {
      if ((registerObj.password === registerObj.confirmPassword) && passwordStore.passwordValidityCheck) {
        commonEntry.changePassword(registerObj as UpdatePasswordObj);
      }
    }
    this.closeErrorMsg = false;
  }

  /* istanbul ignore next */
  @Watch('submitResponse')
  onChildChanged(val: any) {
    if (val.status == 200) {
      this.adjustPopup();
    }
  }

  public closePopup() {
    this.confirmPassObj = {
      confirmPassword: passwordStore.setConfirmPassword(''),
      oldPassword: passwordStore.setOldPassword(''),
      password: passwordStore.setPassword('')
    };
    this.closeChangePassword = !this.closeChangePassword;
    this.reload = !this.reload;
    commonEntry.submitMutate({});
    /* istanbul ignore else */
    if (UIkit) {
      UIkit.modal('#password-screen').hide();
    }
  }

  public adjustPopup() {
    this.closePopup();
    /* istanbul ignore else */
    if (UIkit && UIkit.modal('#modal-password-updated')) {
      UIkit.modal('#modal-password-updated').show();
    }
  }

  public oldPasswordError() {
    commonEntry.submitClear();
  }
}